export default __webpack_public_path__ + "38c4264fa4bc17d4c93d146006f1ca61.png";